<template>
  <div class="outerDiv">
    <header>
      <img alt="Vue logo" src="../assets/SCWEST LOGO.jpg"  class="headerLogo">
      <div class="horizFlex hbuttons" v-if="isLoggedIn">
          <button v-bind:class="adminButtonClass('People')" v-on:click='selectAdmin("People")'>
            <p class="modeText">{{modePeople}}</p>
            <img src="../assets/modes/users-group.svg" alt=""  class="modeImage" v-if="adminIsSelected('People')">
            <img src="../assets/modes/users-group.svg" alt=""  class="modeImage" v-if="adminIsSelected('People')==false">
          </button>
          <button v-bind:class="adminButtonClass('Club')" v-on:click='selectAdmin("Club")'>
            <p class="modeText">{{modeClubs}}</p>
            <img src="../assets/modes/teamwork.svg" alt=""  class="modeImage" v-if="adminIsSelected('Club')">
            <img src="../assets/modes/teamwork.svg" alt=""  class="modeImage" v-if="adminIsSelected('Club')==false">
          </button>
          <button v-bind:class="adminButtonClass('Election')" v-on:click='selectAdmin("Election")'>
             <p class="modeText">{{modeElections}}</p>
            <img src="../assets/modes/ballot-box.svg" alt=""  class="modeImage" v-if="adminIsSelected('Election')">
            <img src="../assets/modes/ballot-box.svg" alt=""  class="modeImage" v-if="adminIsSelected('Election')==false">
          </button>
           <button v-bind:class="adminButtonClass('report')" v-on:click='selectAdmin("report")'  > <!--class="buttonMode buttonModeDisabled" -->
             <p class="modeText">{{modeReports}}</p>
            <img src="../assets/modes/report.svg" alt=""  class="modeImage" v-if="adminIsSelected('report')">
            <img src="../assets/modes/report.svg" alt=""  class="modeImage" v-if="adminIsSelected('report')==false">
          </button>
          <button v-bind:class="adminButtonClass('Super')" v-on:click='selectAdmin("Super")' >
             <p class="modeText">{{modeAdmin}}</p>
            <img src="../assets/modes/admin-with-cogwheels.svg" alt=""  class="modeImage" v-if="adminIsSelected('Super')">
            <img src="../assets/modes/admin-with-cogwheels.svg" alt=""  class="modeImage" v-if="adminIsSelected('Super')==false">
          </button>
      </div>

        <div class="vertFlex" v-if="isLoggedIn">
          <p class="userName">{{personDisplayText}}</p>
          <p class="linkButton linkButtonOrange" v-on:click="logout">{{logoutButtonText}}</p>
          <p class="linkButton linkButtonOrange" v-on:click='changepass'>{{changePasswordText}}</p>
          <div>
            <p class="footerText">{{footerText}}</p>
            <img alt="logo" src="../assets/Multicard_trans.png"  class="footerLogo">
          </div>
        </div>
      
      
    </header>

    <div class="selectedAdmin">
      
        <div class="loginDiv" v-if="isLoggedIn==false && isChangePass==false">
          <form v-on:keyup.enter="loginMember()" @submit.prevent>
            <div class="vertFlex">
              <div class="tightFlex">
                  <h3>{{usenamePromptText}}</h3>
                  <input class="usernameText" v-model="userText"  />
              </div>
              <div class="tightFlex">
                  <h3>{{passwordPromptText}}</h3>
                  <input class="passwordText"  v-model="passText" type="password" />
              </div>
              
              <button v-on:click='loginMember' class='loginButton'>{{loginButtonText}}</button>
              <p>{{loginMessage}}</p>

              <div>
                <linkbutton @click="forgotpassword()" toplabel="forgot password"/>
            </div>
            </div>
          </form>
        </div>

        <div class="loginDiv" v-if="isChangePass">
            <form ref="changepassform" v-on:keyup.enter="SaveNewPassword" @submit.prevent>
              <div class="vertFlex">
                <div class="changePass">
                    <formentrystacked inputid="old" inputtype="password" label="Old password" v-model="oldpassword"  isrequired="true" />
                    <formentrystacked  inputid="new" inputtype="password" label="New password" v-model="newpassword" minlength="8" isrequired="true" placeholder="minimum 8 characters"/>
                    <formentrystacked inputid="confirm" inputtype="password" label="Confirm New password" v-model="confirmpassword" minlength="8" isrequired="true" placeholder="minimum 8 characters"/>
                </div>
                
                <div class="horizFlex">

                  <button v-on:click='SaveNewPassword()' class='loginButton'>Save</button>
                  <button v-on:click='cancelchangepass()' class='loginButton'>Cancel</button>
                </div>
              
              </div>
              <div>
                <label class="responsemessage">{{message}}</label>
              </div>
            </form>
          
          
        </div>

        <PersonAdmin v-if="adminIsVisible('People')" :canEdit='canEditPeople'/>
        <ClubAdmin v-if="adminIsVisible('Club')" :canEdit='canEditClub' :personId="person.id"/>
        <ElectionAdmin v-if="adminIsVisible('Election')" :canEdit='canEditElection'/>
        <ReportAdmin v-if="adminIsVisible('report')"/>
        <AdminAdmin v-if="adminIsVisible('Super')" :canEdit='canEditSuper'/>
    </div>

    <!-- <footer>
        <div>
          <p class="footerText">{{footerText}}</p>
          <img alt="logo" src="../assets/Multicard_trans.png"  class="footerLogo">
        </div>
    </footer> -->
  </div>
</template>

<script>
import {HTTP} from '../Repository'
import PersonAdmin from '../components/PersonAdmin.vue'
import ClubAdmin from '../components/ClubAdmin.vue'
import AdminAdmin from '../components/AdminAdmin.vue'
import ElectionAdmin from '../components/ElectionAdmin.vue'
import ReportAdmin from '../components/ReportAdmin.vue'
import datamethods from '../datamethods.js'
import formentrystacked from './entry-stacked.vue'
import linkbutton from './linkbutton.vue'
import tokenhelper from '../tokenhelper.js'
export default {

    components: {
        PersonAdmin,
        ClubAdmin,
        AdminAdmin,
        ElectionAdmin,
        ReportAdmin,
        formentrystacked,
        linkbutton
    },
    mixins:[datamethods,tokenhelper],
    data(){
        return{
            message:'',

            modePeople:"People",
            modeClubs:"Clubs",
            modeElections:"Elections",
            modeReports:"Reports",
            modeAdmin:"Admin",

            canViewPeople:true,
            canEditPeople:'false',
            canViewClub:true,
            canEditClub:'false',
            canViewElection:true,
            canEditElection:'false',
            canViewSuper:true,
            canEditSuper:'false',
            canViewReport:true,

            selectedAdmin:'People',
            isLoggedIn:false,
            isChangePass:false,
            person:{},
            personDisplayText:'',

            userText:'',
            passText:'',

            oldpassword:'',
            newpassword:'',
            confirmpassword:'',

            accessList:{},

            loginButtonText:'Login',
            logoutButtonText:'Logout',
            changePasswordText:'Change Password',
            usenamePromptText:'Username',
            passwordPromptText:'Password',
            footerText:'powered by',
            loginMessage:''
        }
    },
    methods:{
      AddTokenToAPI(){
            var token = this.getToken()   
            HTTP.defaults.headers.post['token']=token
        },
        loginMember(){
          let req = {
            username:this.userText,
            password:this.passText
          }
          this.AddTokenToAPI();
          HTTP.post('login',req)
            .then(response=>{
                
                  this.handleLoginResult(response.data)
                
                
            })
            .catch(e=>{
                console.log("error " + e)
                if(e="Error:Network Error"){e="This application cannot reach its API. Please check with your administrator."}
                this.loginMessage=e
            });
      
          
        },
        handleLoginResult(responseData){
          console.log("loginresult: " + responseData.person)
          if(responseData.Successful){
            this.person= responseData.person
            this.personDisplayText=this.person.name
            this.isLoggedIn=true;

            //set security flags
            this.canViewReport=true;

            var ViewPeople=false
            var EditPeople=false
            var ViewClub=false
            var EditClub=false
            var ViewElection=false
            var EditElection=false
            var ViewSuper=false
            var EditSuper=false

            responseData.accessList.forEach(myFunction2)
      
      
            function myFunction2(item, index, arr) {
              console.log(arr[index].tabName + ' ' + arr[index].canView + ' ' + arr[index].canEdit)
              switch (arr[index].tabName) {
                case 'People':
                  ViewPeople=arr[index].canView;
                  EditPeople=arr[index].canEdit;
                  break;
                case 'Club':
                  ViewClub=arr[index].canView;
                  EditClub=arr[index].canEdit;
                  break;
              
                case 'Election':
                  ViewElection=arr[index].canView;
                  EditElection=arr[index].canEdit;
                  break;
                case 'Super':
                  ViewSuper=arr[index].canView;
                  EditSuper=arr[index].canEdit;
                  break;

              
                default:
                  break;
              }
            }

            this.canViewPeople=ViewPeople
            this.canEditPeople=EditPeople.toString()
            this.canViewClub=ViewClub
            this.canEditClub=EditClub.toString()
            this.canViewElection=ViewElection
            this.canEditElection=EditElection.toString()
            this.canViewSuper=ViewSuper
            this.canEditSuper=EditSuper.toString()

            if(this.canViewPeople==false){
              if(this.canViewClub){
                this.selectAdmin("Club")
              }else if(this.canViewElection){
                this.selectAdmin("Election")
              }else if(this.canViewReport){
                this.selectAdmin("report")
              }else if(this.canViewSuper){
                this.selectAdmin("Super")
              }
            }
          }else{
            this.loginMessage = "Login Failed. Please check your credentials and try again."
          }
          
          //get next data
          
        },
        
        logout(){
          this.isLoggedIn=false;
        },
        async forgotpassword(){
      
         
          var response = await this.forgotMyPassword(this.userText)
        
          if(response.Successful){
            this.loginMessage = "Please check your email, including junk mail/spam, for a reset password email for your account."
          }else{
            this.loginMessage = response.Message
          }
          this.pleaseWait=false;
        },
        async SaveNewPassword(){
          if(this.$refs.changepassform.checkValidity()==false){return}
          
          var response = await this.ChangePassword(this.userText,this.oldpassword, this.newpassword, this.confirmpassword)
        
          if(response.Successful){
            this.password=""
            this.isLoggedIn=false
            this.isChangePass=false
            this.loginMessage="Your password was changed succesfully. Please login"
            this.passText=''
          }else{
            this.message = response.Message
          }
          this.pleaseWait=false;
        },
        changepass(){
          this.isChangePass=true;
          this.oldpassword='',
          this.newpassword=''
          this.confirmpassword=''
          this.message=''
        },
        cancelchangepass(){
          this.isChangePass=false;
        },
        
        selectAdmin(adminName){
          switch (adminName) {
            case 'People':
              if(this.canViewPeople){this.selectedAdmin=adminName;}
              break;
            case 'Club':
              if(this.canViewClub){this.selectedAdmin=adminName;}
              break;
            case 'Election':
              if(this.canViewElection){this.selectedAdmin=adminName;}
              break;
            case 'Super':
              if(this.canViewSuper){this.selectedAdmin=adminName;}
              break;
            case 'report':
              if(this.canViewReport){this.selectedAdmin=adminName;}
              break;
            default:
              break;
          }
          /* let req = {
            personId:this.person.id,
            tabName:adminName
          }
          
          HTTP.post('canaccess',req)
            .then(response=>{
                  this.accessList = response.data
                  this.selectedAdmin=adminName;  
            })
            .catch(e=>{
                console.log("error " + e)
                if(e="Error:Network Error"){e="This application cannot reach its API. Please check with your administrator."}
                this.loginMessage=e
            }); */

            
        },
        adminIsSelected(adminName){
            return this.selectedAdmin==adminName;
        },
        adminIsVisible(adminName){
          return this.selectedAdmin==adminName && this.isLoggedIn && this.isChangePass==false;
        },
        adminButtonClass(adminName){
            if(this.selectedAdmin==adminName)
            {
                return "buttonModeSelected"
            }else{
                switch (adminName) {
                  case 'People':
                    if(!this.canViewPeople){return "buttonModeDisabled" }
                    break;
                  case 'Club':
                    if(!this.canViewClub){return "buttonModeDisabled" }
                    break;
                  case 'Election':
                    if(!this.canViewElection){return "buttonModeDisabled" }
                    break;
                  case 'report':
                    if(!this.canViewReport){return "buttonModeDisabled" }
                    break;
                  case 'Super':
                    if(!this.canViewSuper){return "buttonModeDisabled" }
                    break;
                  default:
                    break;
                }
                return "buttonMode"
            }
            
        }
    },
    mounted(){
      let urlParams = new URLSearchParams(window.location.search)
        let tmp = urlParams.get('email')
        if(tmp!=null){
          this.userText = tmp;
        }

        let tmp2 = urlParams.get('temp')
        if(tmp2!=null){
          this.oldpassword = tmp2;
 
          this.$nextTick(()=>{
            this.isChangePass=true;
          });
        }
        console.log("inmount")

        
    },
    
    
}
</script>

<style scoped>
body{
  font-size:medium;
  text-align: center;
  color:rgb(58, 54, 54);
}
.outerDiv{
  margin:0px;
  padding:0px;
  height:100vh;
  display:grid;
  grid-template-columns:1fr 2fr 2fr;
  grid-template-rows:1fr 4fr;
  grid-template-areas: 
    "header header header"
    "mainbody mainbody mainbody";
}

header{
  grid-area:header;
  margin:0px;
  display:grid;
  grid-template-columns:250px auto 150px;
  grid-template-rows:auto; 
  grid-template-areas: 
    "hlogo hbuttons user";
    
}
.headerLogo{
    margin:20px;
    grid-area:hlogo;
    height:105px;
}
.hbuttons{
  grid-area:hbuttons;
}
footer{
  grid-area:footer;

  display:flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  align-content:space-between; 
}
.footerText{
  font-size:small;
  margin:5px 0px 0px 0px;
}
.footerLogo{
 margin:0px 0px 0px 0px;
 height:45px;
}
.horizFlex{
  display:flex;
  flex-direction: row;
  margin:5px;
}


.selectedAdmin{
    grid-area:mainbody;
    background-color: rgb(196, 218, 226);
  margin:0px;
}

/* mode buttons */
.buttonMode{
  background-color:rgb(0,158,192);
  color:white;
   padding:0px;
   border:none;
   font-size:large;
   margin:25px 5px 10px 5px;
   width: 100px;
   height: 100px;
}
.buttonModeSelected{
    background-color:rgb(248, 169, 121);
    color:white;
  /* color:rgb(0,158,192); */
   padding:0px;
   border:none;
   font-size:large;
   margin:25px 5px 10px 5px;
   width: 100px;
   height: 100px;
   border-color:rgb(0,158,192);
   border-width: 2px;
   border-style:solid;
}

.modeImage{
  height:20px;
}
.buttonModeDisabled{
  background-color: lightgray;
  color:white;
   padding:0px;
   border:none;
   font-size:large;
   margin:25px 5px 10px 5px;
   width: 100px;
   height: 100px;
}
.linkButton{
  background-color: transparent;
  color: rgb(0,158,192);
  font-size:small;
  border:none;
  padding:0px;
  margin:5px;
  text-decoration: underline;
}
.linkButtonMedium{
  font-size:medium;
  
}
.userName{
  font-size:large;
  color:rgb(0,158,192);
  margin: 30px 0px 0px 0px;
}


/* LOGIN */
.loginDiv{
  margin:60px;
  text-align: center;
}
.tightFlex{
  display:grid;
  grid-template-rows:40px auto;
}
.vertFlex{
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.usernameText{
border-radius: 5px;
  margin:15px;
  font-size:inherit;
  border:none;
  width:150px;
}
.passwordText{
border-radius: 5px;
  margin:15px;
  font-size:inherit;
  border:none;
  width:150px;
}
.loginButton{
   background-color:rgb(0,158,192);
  color:white;
   padding:10px;
   border-radius:20px;
   border:none;
   font-size:inherit;
   margin:10px 10px 0px 20px;
   width: 85px;
}
.linkButtonOrange{
  color:rgb(238,120,45);
}
.changePass{
  text-align: center;
  width:250px;
}
</style>
